<tt-page class="col-xs-12 col-md-4 sp-0" *ngIf="!!itemsListSuppliers">
    <tt-card>
        <tt-tabs [(ttSelectedId)]="selectedBgBatchDeliveryAddSelection" (ttSelectedIdChange)="onTabChanged()">
            <tt-tab ttId="all" ttLabel="batchdelivery_receive_all"></tt-tab>
            <tt-tab ttId="to_date" ttLabel="batchdelivery_receive_to_date"></tt-tab>
        </tt-tabs>
    </tt-card>

    <tt-list [ttData]="itemsListSuppliers"></tt-list>
</tt-page>
